var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.372 10.5089C10.7912 10.6487 11.2442 10.4221 11.3839 10.003C11.5237 9.58383 11.2971 9.13077 10.878 8.99105L10.372 10.5089ZM8 8.875H7.2C7.2 9.21934 7.42034 9.52506 7.74702 9.63395L8 8.875ZM8.8 5.21623C8.8 4.7744 8.44183 4.41623 8 4.41623C7.55817 4.41623 7.2 4.7744 7.2 5.21623H8.8ZM10.625 9.75L10.878 8.99105L8.25298 8.11605L8 8.875L7.74702 9.63395L10.372 10.5089L10.625 9.75ZM8 8.875H8.8V5.21623H8H7.2V8.875H8ZM15 8H14.2C14.2 11.4242 11.4242 14.2 8 14.2V15V15.8C12.3078 15.8 15.8 12.3078 15.8 8H15ZM8 15V14.2C4.57583 14.2 1.8 11.4242 1.8 8H1H0.2C0.2 12.3078 3.69218 15.8 8 15.8V15ZM1 8H1.8C1.8 4.57583 4.57583 1.8 8 1.8V1V0.2C3.69218 0.2 0.2 3.69218 0.2 8H1ZM8 1V1.8C11.4242 1.8 14.2 4.57583 14.2 8H15H15.8C15.8 3.69218 12.3078 0.2 8 0.2V1Z",
    fill: "#F84D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeout);
export default __webpack_public_path__ + "static/media/Timeout.ef05d775fad9601ce791760f069a774d.svg";
export { ForwardRef as ReactComponent };